import { render, staticRenderFns } from "./ModalEscolherAluno.vue?vue&type=template&id=1f4f51d2&"
import script from "./ModalEscolherAluno.vue?vue&type=script&lang=js&"
export * from "./ModalEscolherAluno.vue?vue&type=script&lang=js&"
import style0 from "./ModalEscolherAluno.vue?vue&type=style&index=0&id=1f4f51d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports